import { styled } from '@mui/material/styles'
import Popup from 'components/popup/Popup'
import { isMobileDevice } from 'utils/constants'

export const EventDetailsPopup = styled(Popup)(({ theme }) => ({
  width: isMobileDevice() ? 'unset' : 405
}))

export const CustomEventRecurrencePopup = styled(Popup)(() => ({
  width: 225
}))

export const NoteDetailsPopup = styled(Popup)(({ theme }) => ({
  width: 600,
  maxWidth: 600
}))
